// hooks/useDatadogUser.ts
import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { UserProfileDto } from '@/authApiClient';
import { PrivateContextData } from '@/components/private/PrivateContext';

export const useDatadogUser = (
  userProfile: UserProfileDto | undefined,
  contextData: PrivateContextData,
  selectedOrganisationId?: number,
) => {
  useEffect(() => {
    if (!userProfile || typeof window === 'undefined' || !window.DD_RUM) return;

    datadogRum.setUserProperty(
      'user_id',
      userProfile.userId?.toString() || contextData?.userId?.toString(),
    );
    datadogRum.setUserProperty(
      'email',
      userProfile.contactDetails?.email || contextData?.userEmail,
    );
    datadogRum.setUserProperty(
      'name',
      [userProfile?.firstName, userProfile?.lastName]
        .filter(Boolean)
        .join(' ') || undefined,
    );
    datadogRum.setUserProperty(
      'organization_id',
      selectedOrganisationId?.toString(),
    );
  }, [userProfile, contextData, selectedOrganisationId]);
};
